import React, {Component} from 'react';

class WebsiteHeader extends Component {
  render() {
    return(
      <nav className="web-navigation">
        <ul>
          <li>
            <a href="">Asuransi<span className="arrow">&#9660;</span></a>
              <ul className="sub-menu">
                <a href="https://www.pasarpolis.com/asuransi/kesehatan">Asuransi Kesehatan</a>
                <a href="https://www.pasarpolis.com/asuransi/kendaraan">Asuransi Kendaraan</a>
                <a href="https://www.pasarpolis.com/asuransi/kecelakaan">Asuransi Kecelakaan</a>
                <a href="https://www.pasarpolis.com/asuransi/properti">Asuransi Properti</a>
                <a href="https://www.pasarpolis.com/asuransi/jiwa">Asuransi Jiwa</a>
                <a href="https://www.pasarpolis.com/asuransi/perjalanan">Asuransi Perjalanan</a>
              </ul>
          </li>
          <li><a href="">Tentang Kami</a></li>
          <li><a href="">Kontak</a></li>
        </ul>
      </nav>
    )
  }
}

export default WebsiteHeader;



// WEBPACK FOOTER //
// ./src/component/Common/header/website_header.js